import {PixiAnimationAbstract} from "./pixi-animation.abstract";
import {PixiAsset} from "./pixi-assets-manager/asset/pixi-asset";

export class PixiAnimation<T extends string = string> extends PixiAnimationAbstract<T, PixiAsset> {
    async onAssetsLoaded(loaderAssets: Record<T, PixiAsset>) {
        return loaderAssets;
    }
}
